export default "__VITE_ASSET__BggaIPgc__"